<template>
  <div class="d-grid">
    <ul class="message-thread-list">
      <li v-for="thread in threadsForDisplay" :key="thread.id">
        <thread-for-archive-or-deleted v-if="viewType === 'archive'" class="thread-archive" :thread="thread" />
        <thread-for-feed v-else :id="thread.id" :title="thread.title" :original-message="thread.originalMessage"
                         :replies="thread.replies" />
      </li>
    </ul>
    <button v-if="threadsAvailableForLoading" type="button" class="btn btn-primary" @click="showMore">
      {{ i18n.t('member.forums.more_comments') }}
    </button>
  </div>
</template>

<script>
import ThreadForArchiveOrDeleted from './thread-for-archive-or-deleted'
import ThreadForFeed from './thread-for-feed'
import { mapGetters } from 'vuex'
import { nextTick } from 'vue'

export default {
  components: { ThreadForArchiveOrDeleted, ThreadForFeed },
  props: {
    listPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters(['threadsAvailableForLoading', 'threadsForDisplay'])
  },

  updated() {
    nextTick(() =>  {
      document.dispatchEvent(new Event('agra:embedly-div-added'))
    })
  },

  methods: {
    showMore() {
      this.$store.dispatch('getMoreThreads', this.listPath)
    }
  }
}
</script>

<style scoped lang="scss">
  @use "~friendship_styles/colors" as colors;

  .message-thread-list {
    list-style: none;
    padding-inline-start: unset;
    overflow: hidden;
  }

  li:not(:last-child) .thread-archive {
    border-bottom: 1px solid colors.$unobtrusive-text-color;
  }
</style>
